import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const getConfig = async () =>
  httpRequest.get("/inv/auto-statement-config");

export const updateConfig = async (data: any) =>
  httpRequest.put("/inv/auto-statement-config", data);
